import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PublishSection = ({ onPublish, onSaveDraft, isPublishing, errors }) => {
  const hasErrors = Object.keys(errors)?.length > 0;
  
  const checklist = [
    { id: 'title', label: 'Etkinlik başlığı girildi', completed: !errors?.title },
    { id: 'description', label: 'Detaylı açıklama eklendi', completed: !errors?.description },
    { id: 'location', label: 'Konum bilgileri tamamlandı', completed: !errors?.location },
    { id: 'date', label: 'Tarih ve saat belirlendi', completed: !errors?.date && !errors?.time },
    { id: 'pricing', label: 'Fiyatlandırma yapılandırıldı', completed: !errors?.priceOwnBoard },
    { id: 'capacity', label: 'Kapasite ayarları tamamlandı', completed: !errors?.maxParticipants }
  ];
  
  const completedCount = checklist?.filter(item => item?.completed)?.length;
  const completionPercentage = (completedCount / checklist?.length) * 100;
  
  return (
    <div className="bg-card rounded-lg md:rounded-xl lg:rounded-2xl p-4 md:p-6 lg:p-8 shadow-organic">
      <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-4 md:mb-5 lg:mb-6">
        Yayınlama
      </h2>
      <div className="space-y-6 md:space-y-7 lg:space-y-8">
        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm md:text-base font-medium text-foreground">
              Tamamlanma Durumu
            </span>
            <span className="text-sm md:text-base font-semibold text-primary">
              {completedCount}/{checklist?.length}
            </span>
          </div>
          
          <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full bg-primary transition-all duration-500"
              style={{ width: `${completionPercentage}%` }}
            />
          </div>
        </div>
        
        <div className="space-y-2 md:space-y-3">
          {checklist?.map((item) => (
            <div
              key={item?.id}
              className={`flex items-center gap-3 p-3 md:p-4 rounded-lg transition-smooth ${
                item?.completed ? 'bg-success/10' : 'bg-muted'
              }`}
            >
              <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 ${
                item?.completed ? 'bg-success' : 'bg-border'
              }`}>
                {item?.completed && <Icon name="Check" size={14} color="white" />}
              </div>
              <span className={`text-sm md:text-base ${
                item?.completed ? 'text-foreground font-medium' : 'text-muted-foreground'
              }`}>
                {item?.label}
              </span>
            </div>
          ))}
        </div>
        
        {hasErrors && (
          <div className="bg-error/10 border border-error/20 rounded-lg p-4 md:p-5">
            <div className="flex items-start gap-3">
              <Icon name="AlertCircle" size={20} className="text-error flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="text-sm md:text-base font-medium text-foreground mb-2">
                  Eksik Bilgiler
                </h3>
                <p className="text-xs md:text-sm text-muted-foreground">
                  Etkinliği yayınlamak için lütfen tüm zorunlu alanları doldurun.
                </p>
              </div>
            </div>
          </div>
        )}
        
        <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 md:p-5 lg:p-6">
          <div className="flex items-start gap-3 mb-4">
            <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-sm md:text-base font-medium text-foreground mb-2">
                Yayınlama Sonrası
              </h3>
              <ul className="space-y-1 text-xs md:text-sm text-muted-foreground">
                <li>• Etkinliğiniz anında keşif sayfasında görünür olacak</li>
                <li>• Katılımcılar hemen kayıt olmaya başlayabilir</li>
                <li>• E-posta bildirimleri otomatik gönderilir</li>
                <li>• Yayınlandıktan sonra düzenleme yapabilirsiniz</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
          <Button
            variant="outline"
            onClick={onSaveDraft}
            fullWidth
            iconName="Save"
            iconPosition="left"
            className="sm:flex-1"
          >
            Taslak Olarak Kaydet
          </Button>
          
          <Button
            variant="default"
            onClick={onPublish}
            disabled={hasErrors || isPublishing}
            loading={isPublishing}
            fullWidth
            iconName="Send"
            iconPosition="left"
            className="sm:flex-1"
          >
            {isPublishing ? 'Yayınlanıyor...' : 'Etkinliği Yayınla'}
          </Button>
        </div>
        
        <p className="text-xs md:text-sm text-center text-muted-foreground">
          Yayınlayarak{' '}
          <a href="#" className="text-primary hover:underline">
            Kullanım Koşulları
          </a>
          {' '}ve{' '}
          <a href="#" className="text-primary hover:underline">
            Etkinlik Politikası
          </a>
          'nı kabul etmiş olursunuz.
        </p>
      </div>
    </div>
  );
};

export default PublishSection;